import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MaintenanceService } from '../services/maintenance.service';
import { SystemPageRoutes } from '../constants/constants';
import { MaintenanceProbeResult } from '../enums/maintenance.enums';

/**
 * Stands where the landing route used to redirect straight to sign-in, and asks the API whether it
 * is in maintenance first. Nobody should be offered a sign-in they cannot complete.
 *
 * Only the landing route is gated. A System Administrator still reaches sign-in by going to
 * /sign-in directly, which is how they get in to verify a release.
 */
export const maintenanceLandingGuard: CanActivateFn = async (_route, _state) => {
  const maintenanceService = inject(MaintenanceService);
  const router = inject(Router);

  // The probe runs unauthenticated, which is the point: the maintenance check answers ahead of
  // authorization, so the caller does not need to be signed in to learn the site is down.
  //
  // Only a maintenance answer diverts. An unreachable API is not evidence of maintenance, and
  // telling a user the site is down for scheduled work when it might be an outage is a claim this
  // has not earned - so anything else goes to sign-in.
  if (await maintenanceService.probe() === MaintenanceProbeResult.Maintenance) {
    maintenanceService.resumeOnMaintenancePage();
    return router.createUrlTree(SystemPageRoutes.MAINTENANCE());
  }

  return router.createUrlTree(['sign-in']);
};
